import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-cb24678a")

_pushScopeId("data-v-cb24678a")
const _hoisted_1 = { class: "page" }
const _hoisted_2 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Get Started ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Already a Member? ")
const _hoisted_5 = /*#__PURE__*/_createVNode("source", { types: "video/mp4; codecs=\"h.264\"" }, null, -1)
const _hoisted_6 = { class: "center center2" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Get Started ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Already a Member? ")
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Our Coaches ")
const _hoisted_12 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_14 = { key: 1 }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Live Classes")
const _hoisted_16 = { class: "text-sm" }
const _hoisted_17 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_18 = {
  class: "text-sm",
  style: {"font-size":"100%"}
}
const _hoisted_19 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_20 = { class: "text-sm" }
const _hoisted_21 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Join class")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("Browse Classes")
const _hoisted_25 = {
  key: 0,
  class: "ion-text-center"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Navbar = _resolveComponent("Navbar")
  const _component_ion_header = _resolveComponent("ion-header")
  const _component_ion_img = _resolveComponent("ion-img")
  const _component_ion_row = _resolveComponent("ion-row")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_col = _resolveComponent("ion-col")
  const _component_ion_slide = _resolveComponent("ion-slide")
  const _component_ion_slides = _resolveComponent("ion-slides")
  const _component_ion_label = _resolveComponent("ion-label")
  const _component_ion_card = _resolveComponent("ion-card")
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_grid = _resolveComponent("ion-grid")
  const _component_ion_spinner = _resolveComponent("ion-spinner")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_header, { class: "ion-no-border web-only" }, {
        default: _withId(() => [
          _createVNode(_component_Navbar)
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_1, [
            _createVNode(_component_ion_grid, { class: "mobile-padding" }, {
              default: _withId(() => [
                _createVNode(_component_ion_row, {
                  class: "",
                  style: {"padding":"0","margin-bottom":"20px","border-radius":"7px"}
                }, {
                  default: _withId(() => [
                    _createVNode(_component_ion_col, { STYLE: "padding:0;margin:0" }, {
                      default: _withId(() => [
                        _createVNode(_component_ion_row, { class: "home-banner" }, {
                          default: _withId(() => [
                            _createVNode(_component_ion_slides, {
                              class: "home-slides",
                              pager: "true",
                              options: _ctx.slideOpts
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_ion_slide, null, {
                                  default: _withId(() => [
                                    _createVNode(_component_ion_row, { class: "logo" }, {
                                      default: _withId(() => [
                                        _createVNode(_component_ion_img, {
                                          src: _ctx.client.logo,
                                          class: "logo-img"
                                        }, null, 8, ["src"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_ion_col, { class: "center-landing" }, {
                                      default: _withId(() => [
                                        _createVNode("div", {
                                          innerHTML: _ctx.client.home_banner
                                        }, null, 8, ["innerHTML"]),
                                        _hoisted_2,
                                        _createVNode(_component_ion_button, {
                                          onClick: _cache[1] || (_cache[1] = () => _ctx.router.push('/join')),
                                          color: "light"
                                        }, {
                                          default: _withId(() => [
                                            _hoisted_3
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode("p", {
                                          style: !_ctx.isMobile && 'cursor: pointer'
                                        }, [
                                          _hoisted_4,
                                          _createVNode("a", {
                                            onClick: _cache[2] || (_cache[2] = () => _ctx.router.push('/login'))
                                          }, "Log in")
                                        ], 4)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_ion_row, { class: "fullscreen-bg" }, {
                                      default: _withId(() => [
                                        _createVNode("video", {
                                          src: _ctx.isMobile ? _ctx.client.mobile_video : _ctx.client.web_video,
                                          muted: "",
                                          autoplay: "",
                                          loop: "",
                                          id: "bgvid",
                                          playsInline: ""
                                        }, [
                                          _hoisted_5
                                        ], 8, ["src"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_slide, null, {
                                  default: _withId(() => [
                                    _createVNode("div", {
                                      class: "slide2",
                                      style: {
												'background-image':
													'url(' + _ctx.client.home_banner_image + ')',
											}
                                    }, [
                                      _createVNode("div", _hoisted_6, [
                                        _createVNode("div", {
                                          innerHTML: _ctx.client.home_banner2
                                        }, null, 8, ["innerHTML"]),
                                        _createVNode(_component_ion_button, {
                                          onClick: _cache[3] || (_cache[3] = () => _ctx.router.push('/join')),
                                          color: "light"
                                        }, {
                                          default: _withId(() => [
                                            _hoisted_7
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode("p", {
                                          style: !_ctx.isMobile && 'cursor: pointer'
                                        }, [
                                          _hoisted_8,
                                          _createVNode("a", {
                                            onClick: _cache[4] || (_cache[4] = () => _ctx.router.push('/login'))
                                          }, "Log in")
                                        ], 4)
                                      ])
                                    ], 4)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["options"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (_ctx.focusType == 'coaches' && !_ctx.isMobile)
                  ? (_openBlock(), _createBlock("div", _hoisted_9, [
                      (!_ctx.trainerLoading && !_ctx.isMobile)
                        ? (_openBlock(), _createBlock(_component_ion_row, { key: 0 }, {
                            default: _withId(() => [
                              _hoisted_10,
                              _hoisted_11
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _hoisted_12,
                      (!_ctx.trainerLoading && !_ctx.isMobile)
                        ? (_openBlock(), _createBlock(_component_ion_row, {
                            key: 1,
                            class: "web-only"
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.trainers, (trainer, index) => {
                                return (_openBlock(), _createBlock(_component_ion_col, {
                                  size: "12",
                                  "size-lg": "4",
                                  "size-md": "4",
                                  "size-sm": "12",
                                  key: index
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_ion_card, {
                                      button: "",
                                      onClick: ($event: any) => (_ctx.openTrainerVideos(trainer)),
                                      class: "trainer-card",
                                      style: {
										'background-image': 'url(' + trainer.imgURL + ')',
									}
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_ion_label, { color: "primary" }, {
                                          default: _withId(() => [
                                            _createVNode("strong", null, _toDisplayString(trainer.name), 1),
                                            _hoisted_13,
                                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(trainer.categories, (category, index) => {
                                              return (_openBlock(), _createBlock("span", {
                                                class: "text-secondary",
                                                key: index
                                              }, [
                                                _createVNode("strong", null, _toDisplayString(category), 1)
                                              ]))
                                            }), 128))
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick", "style"])
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.focusType == 'classes' && !_ctx.isMobile)
                  ? (_openBlock(), _createBlock("div", _hoisted_14, [
                      (
								_ctx.content.liveClasses.length > 0 && !_ctx.classesLoading && !_ctx.isMobile
							)
                        ? (_openBlock(), _createBlock(_component_ion_row, {
                            key: 0,
                            class: "web-only"
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_ion_col, { style: {"margin-top":"10px"} }, {
                                default: _withId(() => [
                                  _hoisted_15
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (
								_ctx.content.liveClasses.length > 0 && !_ctx.classesLoading && !_ctx.isMobile
							)
                        ? (_openBlock(), _createBlock(_component_ion_row, {
                            key: 1,
                            class: "web-only row-border",
                            style: {"padding-bottom":"20px","margin-bottom":"10px"}
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.content.liveClasses, (liveClass, index) => {
                                return (_openBlock(), _createBlock(_component_ion_col, {
                                  size: "4",
                                  key: index + liveClass.name
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_ion_card, {
                                      class: "live-class-card",
                                      style: {
										'background-image':
											'url(' + liveClass.trainerData.imgURL + ')',
									}
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_ion_grid, null, {
                                          default: _withId(() => [
                                            _createVNode(_component_ion_row, null, {
                                              default: _withId(() => [
                                                _createVNode(_component_ion_col, null, {
                                                  default: _withId(() => [
                                                    _createVNode("span", _hoisted_16, _toDisplayString(new Date(
														liveClass.date.seconds * 1000
													).toLocaleString()), 1),
                                                    _hoisted_17,
                                                    _createVNode("span", _hoisted_18, [
                                                      _createVNode("strong", null, _toDisplayString(liveClass.name), 1)
                                                    ]),
                                                    _hoisted_19,
                                                    _createVNode("span", _hoisted_20, _toDisplayString(liveClass.trainerData.name), 1),
                                                    _hoisted_21,
                                                    _hoisted_22,
                                                    _createVNode(_component_ion_button, {
                                                      color: "primary",
                                                      size: "small",
                                                      style: {"margin":"0"},
                                                      onClick: ($event: any) => (_ctx.openModal(liveClass))
                                                    }, {
                                                      default: _withId(() => [
                                                        _createVNode(_component_ion_icon, { icon: _ctx.playCircleOutline }, null, 8, ["icon"]),
                                                        _hoisted_23
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["onClick"])
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1032, ["style"])
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (!_ctx.classesLoading && !_ctx.isMobile)
                        ? (_openBlock(), _createBlock(_component_ion_row, { key: 2 }, {
                            default: _withId(() => [
                              _hoisted_24
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (!_ctx.classesLoading && !_ctx.isMobile)
                        ? (_openBlock(), _createBlock(_component_ion_row, {
                            key: 3,
                            class: "web-only"
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.content.categories, (category, index) => {
                                return (_openBlock(), _createBlock(_component_ion_col, {
                                  size: "12",
                                  "size-lg": "3",
                                  "size-md": "4",
                                  "size-sm": "12",
                                  key: category?.name + index
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_ion_card, {
                                      button: "",
                                      onClick: () => _ctx.pullClasses(category?.name),
                                      class: "category-cards",
                                      style: {
										'background-image': 'url(' + category?.imgURL + ')',
									}
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_ion_label, { class: "text-bold text-secondary" }, {
                                          default: _withId(() => [
                                            _createTextVNode(_toDisplayString(category?.name), 1)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick", "style"])
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            (_ctx.classesLoading && !_ctx.isMobile)
              ? (_openBlock(), _createBlock("div", _hoisted_25, [
                  _createVNode(_component_ion_spinner, {
                    class: "spinner",
                    name: "crescent"
                  })
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})